export interface iTipoFactura {
    id: number,
    value: string
}

export const TiposDeFacturasRecibidas: iTipoFactura[] = [
    {
        id: 0,
        value: ''
    }, {
        id: 1,
        value: 'Operación interior'
    }, {
        id: 2,
        value: 'Adquisiciones intracomunitarias'
    }, {
        id: 3,
        value: 'Importaciones'
    }, {
        id: 4,
        value: 'Operacion Interior (Bien de inversión)'
    }, {
        id: 5,
        value: 'Adquisiciones intracomunitarias (Bien de inversión)'
    }, {
        id: 6,
        value: 'Adquisiciones intracomunitarias (Servicios)'
    }, {
        id: 7,
        value: 'Importaciones ( Bien de inversión)'
    }, {
        id: 8,
        value: 'Inversión Sujeto Pasivo'
    }, {
        id: 9,
        value: 'Inversión Sujeto Pasivo (Bienes de inversión)'
    }, {
        id: 10,
        value: 'Compensación REAGP'
    }
];

export const TiposDeFacturasEmitidas: iTipoFactura[] = [
    {
        id: 0,
        value: ''
    }, {
        id: 1,
        value: 'Operación interior'
    }, {
        id: 2,
        value: 'Entregas Intracomunitarias de Bienes'
    }, {
        id: 3,
        value: 'Exportaciones'
    }, {
        id: 4,
        value: 'Operación Interior (Bienes Inversión)'
    }, {
        id: 5,
        value: 'Entregas Intracomunitarias de servicios'
    }, {
        id: 6,
        value: 'Exportaciones de servicios'
    }, {
        id: 7,
        value: 'Inversión sujeto pasivo'
    }
];